import {
	Component,
} from 'react';
/* @startCleanup REACT_18_GLOBAL_MODAL */
import { render as renderLegacy } from 'base/wrapped-render';
/* @endCleanup REACT_18_GLOBAL_MODAL */
import { render } from 'base/wrapped-render-v2';
import {
	GlobalModal,
} from './global-modal.react';
import { ifFeature } from '@bamboohr/utils/lib/feature';

class GlobalModalErrorBoundary extends Component {
	componentDidCatch(error, info) {
		Rollbar.error('Global Modal', {error, info});
	}

	render() {
		return (
			<GlobalModal { ...this.props } />
		);
	}
}

export function initGlobalModal() {
	const element = document.createElement('div');
	/* @startCleanup REACT_18_GLOBAL_MODAL */
	if (ifFeature('REACT_18_GLOBAL_MODAL', true)) {
	/* @endCleanup REACT_18_GLOBAL_MODAL */
		render({
			children: <GlobalModalErrorBoundary />,
			attachedElement: element,
		});
	/* @startCleanup REACT_18_GLOBAL_MODAL */
	} else {
		renderLegacy(<GlobalModalErrorBoundary />, element);
	}
	/* @endCleanup REACT_18_GLOBAL_MODAL */
}

export function initLockModal() {
	const element = document.createElement('div');
	/* @startCleanup REACT_18_GLOBAL_MODAL */
	if (ifFeature('REACT_18_GLOBAL_MODAL', true)) {
	/* @endCleanup REACT_18_GLOBAL_MODAL */
		render({
			children: <GlobalModalErrorBoundary namespace="LockModal"/>,
			attachedElement: element,
		});
	/* @startCleanup REACT_18_GLOBAL_MODAL */
	} else {
		renderLegacy(<GlobalModalErrorBoundary namespace="LockModal"/>, element);
	}
	/* @endCleanup REACT_18_GLOBAL_MODAL */
}
